export enum NormalizationFieldExceptionCriteriaDataType {
    Numeric = 1,
    String = 2,
    Boolean = 3,
    Selection =4
}
